import { useState } from 'react';
import { Calculator, Delete } from 'lucide-react';

export default function CashCalculator({ total }) {
  const [received, setReceived] = useState('');
  const numValue = received ? parseFloat(received) : 0;
  const change = received ? numValue - total : null;

  const quickAmounts = [50, 100, 200, 500, 1000].filter(a => a >= total);

  const pressKey = (key) => {
    if (key === 'C') { setReceived(''); return; }
    if (key === 'DEL') { setReceived(prev => prev.slice(0, -1)); return; }
    if (key === '.' && received.includes('.')) return;
    if (key === '.' && received === '') { setReceived('0.'); return; }
    setReceived(prev => prev + key);
  };

  const numKeys = ['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '.', 'DEL'];

  return (
    <div className="bg-stone-50 rounded-xl p-4 space-y-3" data-testid="cash-calculator">
      <div className="flex items-center gap-2 text-sm font-medium text-stone-700">
        <Calculator className="w-4 h-4 text-orange-600" strokeWidth={1.5} />
        Calculadora de Cambio
      </div>

      {/* Display */}
      <div className="bg-white rounded-xl border border-stone-200 p-3">
        <p className="text-xs text-stone-400 uppercase tracking-wider">Monto recibido</p>
        <p data-testid="cash-received-display" className="text-3xl font-outfit font-bold text-stone-900 text-right mt-1">
          ${received || '0.00'}
        </p>
      </div>

      {/* Quick amounts */}
      {quickAmounts.length > 0 && (
        <div className="flex gap-2 flex-wrap">
          {quickAmounts.map(amt => (
            <button key={amt} data-testid={`quick-amount-${amt}`}
              onClick={() => setReceived(String(amt))}
              className={`flex-1 min-w-[60px] py-2.5 rounded-xl text-sm font-semibold transition-all active:scale-95 min-h-[44px] ${
                numValue === amt ? 'bg-orange-700 text-white shadow-sm' : 'bg-white border border-stone-300 text-stone-700 hover:border-orange-400'
              }`}>
              ${amt}
            </button>
          ))}
        </div>
      )}

      {/* Numeric keypad */}
      <div className="grid grid-cols-4 gap-1.5">
        {numKeys.map(key => (
          <button key={key} data-testid={`numpad-${key}`}
            onClick={() => pressKey(key)}
            className={`h-14 rounded-xl text-lg font-semibold transition-all active:scale-95 ${
              key === 'DEL'
                ? 'bg-stone-200 text-stone-700 hover:bg-stone-300'
                : 'bg-white border border-stone-200 text-stone-900 hover:bg-stone-100 hover:border-stone-300'
            } flex items-center justify-center`}>
            {key === 'DEL' ? <Delete className="w-5 h-5" strokeWidth={1.5} /> : key}
          </button>
        ))}
        <button data-testid="numpad-C" onClick={() => pressKey('C')}
          className="h-14 rounded-xl text-base font-semibold bg-red-100 text-red-700 hover:bg-red-200 transition-all active:scale-95 flex items-center justify-center">
          C
        </button>
      </div>

      {/* Change result */}
      {change !== null && (
        <div className={`text-center rounded-xl p-4 ${change >= 0 ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
          <p className="text-xs text-stone-500 uppercase tracking-wider">Cambio</p>
          <p className={`text-3xl font-outfit font-bold mt-1 ${change >= 0 ? 'text-green-700' : 'text-red-700'}`}>
            {change >= 0 ? `$${change.toFixed(2)}` : `Falta $${Math.abs(change).toFixed(2)}`}
          </p>
        </div>
      )}
    </div>
  );
}
